import { makeVar } from '@apollo/client';

export const scheduleTypeCellParamTemplateId = 0;

export const seasonalityTemplateModalVar = makeVar({ open: false, templateId: scheduleTypeCellParamTemplateId });